import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createFsCacheProxy } from '@segment/utils/fsCache';
export var fetchGrowthCenterData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return createFsCacheProxy(["growthCenter/growthCenterDataQuery"], function () {
              return client.get("/content/rawEntries/growthCenterLandingPage").then(function (data) {
                var _data$items$0$fields, _data$items, _data$items$;

                return (_data$items$0$fields = (_data$items = data.items) === null || _data$items === void 0 ? void 0 : (_data$items$ = _data$items[0]) === null || _data$items$ === void 0 ? void 0 : _data$items$.fields) !== null && _data$items$0$fields !== void 0 ? _data$items$0$fields : null;
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchGrowthCenterData(_x) {
    return _ref.apply(this, arguments);
  };
}();